module.exports = __webpack_public_path__ + "media/images/background-7ab2bb89052743166ebbb7c9ff5ca867.jpg";